/* eslint-disable no-console */
export class WebViewStrategy {
  onSuccess(boxNumber, citiboxId, deliveryId) {
    if (window.CitiboxCourierSDK?.onSuccess) {
      window.CitiboxCourierSDK.onSuccess(boxNumber, citiboxId, deliveryId);
    }
  }

  onError(errorCode) {
    if (window.CitiboxCourierSDK?.onError) {
      window.CitiboxCourierSDK.onError(errorCode);
    }
  }

  onFail(failureCode) {
    if (window.CitiboxCourierSDK?.onFail) {
      window.CitiboxCourierSDK.onFail(failureCode);
    }
  }

  onCancel(cancelCode) {
    if (window.CitiboxCourierSDK?.onCancel) {
      window.CitiboxCourierSDK.onCancel(cancelCode);
    }
  }

  openBLE(url, mac, ssid, serviceUUID, scommandUUID, sreplyUUID, openToken, otaServiceUUID, otaControlUUID, otaDataUUID) {
    console.log('Called openBLE with: ', mac, ssid, url, serviceUUID, scommandUUID, sreplyUUID, openToken, otaServiceUUID, otaControlUUID, otaDataUUID);
  }

  cancelOpenBLE() {
    console.log('Called cancelOpenBLE');
  }

  blePermissionsStatus() {
    console.log('Called blePermissionsStatus');
  }

  characteristicsSDK() {
    console.log('Called characteristicsSDK');
  }

  sdkInfo() {
    console.log('Called sdkInfo');
  }

  onSessionToken(sessionToken) {
    if (window.CitiboxCourierSDK?.onSessionToken) {
      window.CitiboxCourierSDK.onSessionToken(sessionToken);
    }
  }
}
